module.exports = __webpack_public_path__ + "static/media/carbon-2.ba16c1c5.png";